import React from "react"

import ProductPage from "../../components/product_page"

const product = "metal-roofing"

const Page = () => <ProductPage product={product} />

export default Page
